import { render, staticRenderFns } from "./materialTypeManage.vue?vue&type=template&id=1dda65b9"
import script from "./materialTypeManage.vue?vue&type=script&lang=js"
export * from "./materialTypeManage.vue?vue&type=script&lang=js"
import style0 from "./materialTypeManage.vue?vue&type=style&index=0&id=1dda65b9&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dda65b9')) {
      api.createRecord('1dda65b9', component.options)
    } else {
      api.reload('1dda65b9', component.options)
    }
    module.hot.accept("./materialTypeManage.vue?vue&type=template&id=1dda65b9", function () {
      api.rerender('1dda65b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/materialTypeManage.vue"
export default component.exports